"use client";
import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CardCarousel } from "./CardCarousel/CardCarousel";
import style from "./CommentCarousel.module.scss";
import { useGsapBurgerTimeline } from "@/utils/useGsapBurgerTimeline";
import Wave from "react-wavify";

interface CommentCarouselProps {
  testimonies?: any;
  isWithoutMargin?: boolean;
}

export const CommentCarousel = ({
  testimonies,
  isWithoutMargin = false,
}: CommentCarouselProps) => {
  const containerRef = useRef();
  useGsapBurgerTimeline({
    triggerClass: style.carouselWrap,
    startAdjustment: -128,
  });

  const [amplitude, setAmplitude] = useState(60);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const mobile = window.innerWidth <= 767;
      setAmplitude(mobile ? 25 : 60);
    }
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };
  if (!testimonies || testimonies.length === 0) return null;
  return (
    <>
      <Wave
        className={style.wave}
        fill="var(--primary)"
        paused={false}
        style={{ display: "flex" }}
        options={{
          height: 50,
          amplitude: amplitude,
          speed: 0.25,
          points: 2,
        }}
      />
      <section
        className={style.carouselWrap}
        style={isWithoutMargin ? { marginBottom: 0 } : {}}
        ref={containerRef}
      >
        <div className="container">
          <Slider {...settings}>
            {testimonies.map((card, index) => (
              <div key={index}>
                <CardCarousel card={card} />
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
};
